import React, { useEffect, useRef, useState } from 'react';
import SectionContentItem from '../SectionContentItem';
import SectionHeaderOverview from '../SectionHeaderOverview';
import {
  PlusOutlined,
  MinusOutlined,
} from '@ant-design/icons';

/** How long a question opened by a link stays highlighted. */
export const FOCUS_MS = 2500;

/** The DOM id of a question's item, the target of a link to it. */
export const questionElementId = (questionId) => `question-${questionId}`;

export const DisplaySection = (props) => {

  const { activeSection, data, showMcq, speechByQuestionId, focusQuestionId, onFocused } = props;
  const [displaySection, setDisplaySection] = useState(true);
  // The question opened by a link (?question=<id>): scrolled to and highlighted for a moment.
  const [focusedId, setFocusedId] = useState(null);
  const focused = useRef(null);

  useEffect(() => {
    if (!focusQuestionId) {
      focused.current = null;
      return;
    }
    if (focused.current === focusQuestionId) return;
    if (!data?.some((elem) => elem?.question?.id === focusQuestionId)) return;
    // A collapsed section is display:none, so open it first; this runs again once it shows.
    if (!displaySection) {
      setDisplaySection(true);
      return;
    }
    const element = document.getElementById(questionElementId(focusQuestionId));
    if (!element) return;
    focused.current = focusQuestionId;
    element.scrollIntoView({ block: "center", behavior: "smooth" });
    setFocusedId(focusQuestionId);
    if (onFocused) onFocused(focusQuestionId);
  }, [focusQuestionId, data, displaySection, onFocused]);

  useEffect(() => {
    if (!focusedId) return undefined;
    const timer = setTimeout(() => setFocusedId(null), FOCUS_MS);
    return () => clearTimeout(timer);
  }, [focusedId]);

  return (
    data?.length > 0 &&
    <section className="questions-section pt-30">
      <div className="section-header mb-20">
        <SectionHeaderOverview
          activeSection={activeSection}
          data={data}
        />
        <div className="display-section" onClick={() => setDisplaySection(prev => !prev)}>
          {displaySection ? <MinusOutlined /> : <PlusOutlined />}
        </div>
      </div>
      <div className={`section-content ${displaySection ? '' : 'hidden'}`}>
        {
          data.map((elem, index) => {
            const questionId = elem?.question?.id;
            const isFocused = !!questionId && questionId === focusedId;
            return (
              <div
                key={questionId ?? index}
                id={questionId ? questionElementId(questionId) : undefined}
                className={`section-content-item-container${isFocused ? ' is-focused' : ''}`}
              >
                <SectionContentItem
                  data={elem}
                  serial={index + 1}
                  activeSection={activeSection}
                  plagiarismConfig={props.plagiarismConfig}
                  speechMs={speechByQuestionId?.[questionId]}
                />
                {
                  !(data.length - 1 === index) &&
                  <div className="separator mt-16 mb-24"></div>
                }
              </div>
            );
          })
        }
      </div>
    </section>
  )
};
